import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

import CreateCustomer from "@/features/customers/create-customer/create-customer";
import CustomersTable from "@/features/customers/customers-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute(
  "/_app/(single-location)/museum/$museumId/customers/",
)({
  beforeLoad: ({ context }) => {
    const canReadCustomers = context.ability.can("read", "Customer");

    if (!canReadCustomers) {
      console.error("User does not have permission to read customers");
      redirect({
        to: "/unauthorized",
        throw: true,
      });
    }
  },
  component: () => <CustomersPage />,
});

function CustomersPage() {
  const { museumId } = Route.useParams();

  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Kunderegister</Trans>
        </h1>

        <Can I="create" a="Customer">
          <CreateCustomer museumId={museumId} />
        </Can>
      </Flex>

      <CustomersTable museumId={museumId} />
    </Box>
  );
}
